<template>
  <div id="orderlist">
    <el-row>
      <h2>人员管理列表</h2>
    </el-row>
    <el-row>
      <el-form :inline="true" :model="searchForm" ref="searchForm" class="demo-form-inline"
        style="padding-top:0;margin-top:0">
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="5">
          <el-form-item label="状态：" style="width:100%">
            <label slot="label">状&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;态：</label>
            <el-select v-model="searchForm.STATUS" placeholder="请选择">
              <el-option v-for="item in status" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="10" :sm="10" :md="10" :lg="10" :xl="19">
          <el-form-item label="姓名：" style="width:100%">
            <label slot="label">姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名：</label>
            <el-input placeholder="姓名" v-model="searchForm.NAME" clearable @keyup.enter.native="handleSearch()">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="10" :sm="10" :md="10" :lg="10" :xl="5">
          <el-form-item label="联系电话：">
            <el-input placeholder="联系电话" v-model="searchForm.CELLPHONE" clearable @keyup.enter.native="handleSearch()">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="10" :sm="10" :md="10" :lg="10" :xl="5">
          <el-form-item label="部门：">
            <label slot="label">部&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;门：</label>
            <el-select v-model="searchForm.DEPARTMENT" placeholder="请选择" clearable filterable>
              <el-option v-for="item in departments" :key="item.value" :label="item.DEPARTMENT_NAME"
                :value="item.DEPARTMENT_ID"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="10" :sm="10" :md="10" :lg="10" :xl="5">
          <el-form-item label="职位：">
            <label slot="label">职&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;位：</label>
            <el-input placeholder="职位" v-model="searchForm.TITLE" clearable @keyup.enter.native="handleSearch()">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4">
          <el-form-item>
            <el-button id="search" @click="handleSearch()">筛选</el-button>
          </el-form-item>
        </el-col>
      </el-form>
    </el-row>
    <el-row>
      <el-col :span="4">
        <el-button size="small" @click="addFormVisible = true" style="margin-bottom:10px">新增</el-button>
        <el-button size="small" @click="openExportDialog" style="margin-bottom:10px;margin-left:10px">账号导出</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :data="userManageListData" border stripe style="width: 100%">
          <el-table-column type="index" label="序号" width="50" min-width="30"></el-table-column>
          <el-table-column prop="NAME" label="姓名" width="100" min-width="100"></el-table-column>
          <el-table-column prop="CELLPHONE" label="联系电话"></el-table-column>
          <el-table-column prop="DEPARTMENT" label="部门"></el-table-column>
          <el-table-column prop="TITLE" label="职位"></el-table-column>
          <el-table-column v-if="searchForm.STATUS === '1'" fixed="right" label="操作" width="500">
            <template slot-scope="scope">
              <!-- <el-button type="text" size="small" icon="el-icon-edit" @click="allotProject(scope.row)">
                项目点权限
              </el-button> -->
              <el-button type="text" size="small" icon="el-icon-edit" @click="peopleActor(scope.row)">权限分配</el-button>
              <el-button type="text" size="small" icon="el-icon-edit" @click="allotSupplier(scope.row)">供应商权限
              </el-button>
              <el-button type="text" size="small" icon="el-icon-edit" @click="allot(scope.row)">角色分配</el-button>
              <el-button type="text" size="small" icon="el-icon-edit" @click="configureProject(scope.row)">匹配项目点
              </el-button>
              <el-button type="text" size="small" icon="el-icon-edit-outline" @click="editUserForm(scope.row)">修改
              </el-button>
              <el-button type="text" size="small" icon="el-icon-refresh" @click="changeUserPWD(scope.row)">重制密码
              </el-button>
              <el-button type="text" size="small" icon="el-icon-close" style="color:  #F56C6C"
                @click="stopUser(scope.row)">禁用</el-button>
            </template>
          </el-table-column>
          <el-table-column v-else fixed="right" label="操作" width="400">
            <template slot-scope="scope">
              <el-button type="text" size="small" icon="el-icon-check" style="color: #67C23A"
                @click="startUser(scope.row)">启用</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <div class="block">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
        layout="total,prev, pager, next, jumper" :total="totalNum"></el-pagination>
    </div>
    <!-- 新增用户模态框 -->
    <el-dialog title="新增用户" center :visible.sync="addFormVisible" width="600px" :close-on-click-modal="false">
      <el-form :model="addForm" ref="addForm" style="margin-top: 0">
        <el-form-item :label-width="formLabelWidth" prop="name">
          <label slot="label">姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名：</label>
          <el-input v-model="addForm.name" auto-complete="off" clearable></el-input>
        </el-form-item>
        <el-form-item label="手机号码：" :label-width="formLabelWidth" prop="phone">
          <el-input v-model="addForm.phone" auto-complete="off" clearable></el-input>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth" prop="note">
          <label slot="label">备&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;注：</label>
          <el-input v-model="addForm.note" auto-complete="off" clearable></el-input>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth" prop="region">
          <label slot="label">部&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;门：</label>
          <el-select v-model="addForm.region" placeholder="请选择部门" style="width:100%" clearable>
            <el-option v-for="item in departments" :key="item.value" :label="item.DEPARTMENT_NAME"
              :value="item.DEPARTMENT_ID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth" prop="position">
          <label slot="label">职&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;位：</label>
          <el-input v-model="addForm.position" auto-complete="off" clearable></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close('addForm')">取 消</el-button>
        <el-button @click="submitAdd('addForm')" plain>确 定</el-button>
      </div>
    </el-dialog>
    <!-- 修改用户信息模态框 -->
    <el-dialog title="修改用户信息" center :visible.sync="editFormVisible" width="600px" :close-on-click-modal="false">
      <el-form :model="editForm" ref="editForm" style="margin-top: 0">
        <el-form-item :label-width="formLabelWidth" prop="NAME">
          <label slot="label">姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名：</label>
          <el-input v-model="editForm.NAME" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="手机号码：" :label-width="formLabelWidth" prop="CELLPHONE">
          <!-- <el-input v-model="editForm.CELLPHONE" auto-complete="off" disabled></el-input> -->
          <el-input v-model="editForm.CELLPHONE" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth" prop="DESCRIPTION">
          <label slot="label">备&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;注：</label>
          <el-input v-model="editForm.DESCRIPTION" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth" prop="DEPARTMENT">
          <label slot="label">部&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;门：</label>
          <el-select v-model="editForm.DEPARTMENT" placeholder="请选择活动区域" style="width:100%" @change="getDepartmentName">
            <el-option v-for="item in departments" :key="item.value" :label="item.DEPARTMENT_NAME"
              :value="item.DEPARTMENT_ID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="职位：" :label-width="formLabelWidth" prop="TITLE">
          <label slot="label">职&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;位：</label>
          <el-input v-model="editForm.TITLE" auto-complete="off" clearable></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close('editForm')">取 消</el-button>
        <el-button @click="submitEdit('editForm')" plain>确 定</el-button>
      </div>
    </el-dialog>
    <!--角色分配模态框-->
    <el-dialog title="分配角色" center :visible.sync="allotFormVisible" width="600px" @close="resetContent()"
      :close-on-click-modal="false">
      <el-form :model="allotForm" ref="allotForm" :inline="true" class="demo-form-inline" :rules="rules"
        style="margin:0;padding: 0">
        <div style="text-align: center">
          <el-transfer style="text-align: left; display: inline-block" v-model="allotForm.value4" filterable
            :titles="['可分配角色', '已分配角色']" :button-texts="['取消', '分配']"
            :format="{ noChecked: '${total}', hasChecked: '${checked}/${total}' }" :data="data">
            <span slot-scope="{ option }">{{ option.key }} - {{ option.label }}</span>
          </el-transfer>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close('allotForm')">取 消</el-button>
        <el-button @click="submitAllot('allotForm')">确 定</el-button>
      </div>
    </el-dialog>
    <!--项目点权限分配-->
    <el-dialog title="项目点权限分配" center :visible.sync="projectAuthorityFormVisible" width="600px" @close="resetContent()"
      :close-on-click-modal="false">
      <el-form :model="projectAuthorityForm" ref="projectAuthorityForm" :inline="true" class="demo-form-inline"
        :rules="rules" style="margin:0;padding: 0">
        <div style="text-align: center">
          <el-transfer style="text-align: left; display: inline-block" v-model="projectAuthorityForm.value5" filterable
            :titles="['可分配项目点', '已分配项目点']" :button-texts="['取消', '分配']"
            :format="{ noChecked: '${total}', hasChecked: '${checked}/${total}' }" :data="projectData">
            <span slot-scope="{ option }">{{ option.key }} - {{ option.label }}</span>
          </el-transfer>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close('projectAuthorityForm')">取 消</el-button>
        <el-button @click="submitProject('projectAuthorityForm')">确 定</el-button>
      </div>
    </el-dialog>
    <!--供应商权限分配-->
    <el-dialog title="供应商权限分配" center :visible.sync="supplierAuthorityFormVisible" width="600px" @close="resetContent()"
      :close-on-click-modal="false">
      <el-form :model="supplierAuthorityForm" ref="supplierAuthorityForm" :inline="true" class="demo-form-inline"
        :rules="rules" style="margin:0;padding: 0">
        <div style="text-align: center">
          <el-transfer style="text-align: left; display: inline-block" v-model="supplierAuthorityForm.value6" filterable
            :titles="['可分配供应商', '已分配供应商']" :button-texts="['取消', '分配']"
            :format="{ noChecked: '${total}', hasChecked: '${checked}/${total}' }" :data="supplierData">
            <span slot-scope="{ option }">{{ option.key }} - {{ option.label }}</span>
          </el-transfer>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close('supplierAuthorityForm')">取 消</el-button>
        <el-button @click="submitSupplier('supplierAuthorityForm')">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 账号导出模态框 -->
    <el-dialog title="账号导出" center :visible.sync="exportDialogVisible" width="600px" :close-on-click-modal="false"
      @close="resetExportForm">
      <el-form :model="exportForm" ref="exportForm" style="margin-top: 0">
        <el-form-item label="角色：" :label-width="formLabelWidth">
          <el-checkbox v-model="checkAll" @change="handleCheckAllChange" class="export-check-all">全选</el-checkbox>
          <el-checkbox-group v-model="exportForm.actorIds" class="export-actor-checkbox-group"
            @change="handleCheckedActorsChange">
            <el-checkbox v-for="item in actorOptions" :label="item.ACTOR_ID" :key="item.ACTOR_ID">
              {{ item.ACTOR_NAME }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeExportDialog">取 消</el-button>
        <el-button @click="submitExport" plain>确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import util from '@/common/util';
import http from '../api/base/http';
import {
  // eslint-disable-next-line no-unused-vars
  addUser, editUser, formalUserList, getActor, stopUser, submitActor, getProject, submitProject, getSupplier, submitSupplier, temporaryUserList, startUser, changeUserPWD,
  exportUserByActor, getAllActor,
} from '@/api/userManager';

export default {
  data () {
    // 内容验证
    const tel = /^1[3456789]\d{9}$/;
    const validatePhone = (rule, value, callback) => {
      if (value === '') {
        callback('请输入手机号');
      } else if (tel.test(value)) {
        callback();
      } else {
        callback(new Error('请输入正确的手机号'));
      }
    };
    const name = /^[\u4E00-\u9FA5\uf900-\ufa2d·s]{2,20}$/;
    const validateName = (rule, value, callback) => {
      if (value === '') {
        callback('请输入姓名');
      } else if (name.test(value)) {
        callback();
      } else {
        callback(new Error('请输入正确的姓名'));
      }
    };
    const generateData = (_) => {
      const data = [];
      return data;
    };
    const generateProjectData = (_) => {
      const projectData = [];
      return projectData;
    };
    const generateSupplierData = (_) => {
      const supplierData = [];
      return supplierData;
    };
    return {
      loading: false,
      departments: [],
      status: [
        {
          value: '1',
          label: '在职',
        },
        {
          value: '0',
          label: '离职',
        },
      ],
      radio3: '1',
      value1: '',
      actorData: [],
      userManageListData: [],
      addFormVisible: false,
      editFormVisible: false,
      allotFormVisible: false,
      pageSize: 20,
      currentPage: 1,
      index: 0,
      totalNum: 6,
      // 新增form表单
      addForm: {
        name: '',
        phone: '',
        note: '',
        region: '',
        position: '',
      },
      // 修改form表单
      editForm: {
        ID: '',
        NAME: '',
        CELLPHONE: '',
        DESCRIPTION: '',
        DEPARTMENT: '',
        TITLE: '',
        WORK_POSITION: 0,
      },
      // 搜索
      searchForm: {
        STATUS: '1',
        NAME: '',
        CELLPHONE: '',
        DEPARTMENT: '',
        TITLE: '',
      },
      // 角色分配
      allotForm: {
        USER_ID: '',
        value4: [],
      },
      data: generateData(),
      // 项目点权限分配
      projectAuthorityFormVisible: false,
      projectAuthorityForm: {
        USER_ID: '',
        value5: [],
      },
      projectData: generateProjectData(),
      // 供应商权限分配
      supplierAuthorityFormVisible: false,
      supplierAuthorityForm: {
        USER_ID: '',
        value6: [],
      },
      supplierData: generateSupplierData(),
      // 账号导出
      exportDialogVisible: false,
      exportForm: {
        actorIds: [],
      },
      actorOptions: [],
      checkAll: false,
      rules: {
        name: [
          { required: true, validator: validateName, trigger: 'blur' },
        ],
        phone: [
          { required: true, validator: validatePhone, trigger: 'blur' },
        ],
        NAME: [
          { required: true, validator: validateName, trigger: 'blur' },
        ],
        CELLPHONE: [
          { required: true, validator: validatePhone, trigger: 'blur' },
        ],
      },
      formLabelWidth: '100px',
    };
  },
  methods: {
    // 获取正式用户列表
    queryUserManageListData () {
      // 获取企业人员列表
      const data = {
        PAGEINDEX: this.currentPage - 1,
        PAGESIZE: this.pageSize,
        STATUS: Number(this.searchForm.STATUS),
      };
      if (this.searchForm.NAME) {
        data.NAME = this.searchForm.NAME;
      }
      if (this.searchForm.CELLPHONE) {
        data.CELLPHONE = this.searchForm.CELLPHONE;
      }
      if (this.searchForm.DEPARTMENT) {
        data.DEPARTMENT = this.searchForm.DEPARTMENT;
      }
      if (this.searchForm.TITLE) {
        data.TITLE = this.searchForm.TITLE;
      }
      formalUserList(data).then((res) => {
        if (res.length != 0) {
          this.userManageListData = res.length > 0 ? res[0].list : [];
          this.totalNum = res.length > 0 ? res[0].TOTAL_COUNT : 0;
        } else {
          this.userManageListData = res;
          this.totalNum = 0;
        }
        sessionStorage.setItem('FORMAL_USER_MANAGE_SEARCH', JSON.stringify(this.searchForm));
      }).catch((error) => {
        this.$message.show({
          text: error,
          type: 'error',
        });
      });
    },
    // 获取角色
    queryActorData () {
      const data = {
        TC_USER_ID: this.allotForm.USER_ID,
      };
      getActor(data).then((res) => {
        for (let i = 0; i < res[0].NOT_HAS_ACTOR.length; i++) {
          this.data.push({
            label: res[0].NOT_HAS_ACTOR[i].ACTOR_NAME,
            key: res[0].NOT_HAS_ACTOR[i].ACTOR_ID,
          });
        }
        this.allotForm.value4 = res[0].HAS_ACTOR;
      }).catch((error) => {
        this.$message.show({
          text: error,
          type: 'error',
        });
      });
    },
    // 分配角色
    submitAllot (formName) {
      console.log(this.allotForm, 'this.allotForm');
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          const data = {
            TC_USER_ID: this.allotForm.USER_ID,
            ACTOR_IDS: this.allotForm.value4,
          };
          submitActor(data).then((res) => {
            this.$message.show({
              text: '角色分配成功',
              type: 'success',
            });
            this.allotFormVisible = false;
            this.$refs[formName].resetFields();
            this.data = [];
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({
              text: error,
              type: 'error',
            });
            this.data = [];
            document.body.style.cursor = 'default';
          });
        } finally {
          // console.log("我执行完了")
          // document.body.style.cursor="default";
        }
      }
    },
    // 分配角色清空
    resetContent () {
      this.data = [];
      this.projectData = [];
      this.supplierData = [];
    },
    // 获取项目点
    queryProjectData () {
      const data = {
        TC_USER_ID: this.projectAuthorityForm.USER_ID,
      };
      getProject(data).then((res) => {
        for (let i = 0; i < res[0].NOT_HAS_PROJECT.length; i++) {
          this.projectData.push({
            label: res[0].NOT_HAS_PROJECT[i].PROJECT_NAME,
            key: res[0].NOT_HAS_PROJECT[i].PROJECT_ID,
          });
        }
        this.projectAuthorityForm.value5 = res[0].HAS_PROJECT;
      }).catch((error) => {
        this.$message.show({
          text: error,
          type: 'error',
        });
      });
    },
    peopleActor (row) {
      this.$router.push({ name: 'peopleActor' });
      sessionStorage.setItem('USER_ID', row.ID);
    },
    // 分配项目点权限
    submitProject (formName) {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          const data = {
            TC_USER_ID: this.projectAuthorityForm.USER_ID,
            PROJECT_IDS: this.projectAuthorityForm.value5,
          };
          submitProject(data).then((res) => {
            this.$message.show({
              text: '项目点权限分配成功',
              type: 'success',
            });
            this.projectAuthorityFormVisible = false;
            this.$refs[formName].resetFields();
            this.projectData = [];
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({
              text: error,
              type: 'error',
            });
            this.projectData = [];
            document.body.style.cursor = 'default';
          });
        } finally {
          // console.log("我执行完了")
          // document.body.style.cursor="default";
        }
      }
    },
    // 获取供应商
    querySupplierData () {
      const data = {
        TC_USER_ID: this.supplierAuthorityForm.USER_ID,
      };
      getSupplier(data).then((res) => {
        for (let i = 0; i < res[0].NOT_HAS_SUPPLIER.length; i++) {
          this.supplierData.push({
            label: res[0].NOT_HAS_SUPPLIER[i].SUPPLIER_NAME,
            key: res[0].NOT_HAS_SUPPLIER[i].SUPPLIER_ID,
          });
        }
        this.supplierAuthorityForm.value6 = res[0].HAS_SUPPLIER;
      }).catch((error) => {
        this.$message.show({
          text: error,
          type: 'error',
        });
      });
    },
    // 分配供应商权限
    submitSupplier (formName) {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          const data = {
            TC_USER_ID: this.supplierAuthorityForm.USER_ID,
            SUPPLIER_IDS: this.supplierAuthorityForm.value6,
          };
          submitSupplier(data).then((res) => {
            this.$message.show({
              text: '项目点权限分配成功',
              type: 'success',
            });
            this.supplierAuthorityFormVisible = false;
            this.$refs[formName].resetFields();
            this.supplierData = [];
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({
              text: error,
              type: 'error',
            });
            this.supplierData = [];
            document.body.style.cursor = 'default';
          });
        } finally {
          // console.log("我执行完了")
          // document.body.style.cursor="default";
        }
      }
    },
    // 新增用户
    submitAdd (formName) {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          // this.loading = true
          this.$refs[formName].validate((valid) => {
            if (valid) {
              const data = {
                NAME: this.addForm.name,
                CELLPHONE: this.addForm.phone,
                DESCRIPTION: this.addForm.note,
                DEPARTMENT: this.addForm.region,
                TITLE: this.addForm.position,
              };
              addUser(data).then((res) => {
                this.$message.show({
                  text: '新增企业人员成功',
                  type: 'success',
                });
                this.queryUserManageListData();
                this.addFormVisible = false;
                this.$refs[formName].resetFields();
                // this.loading = false
                document.body.style.cursor = 'default';
              }).catch((error) => {
                this.$message.show({
                  text: error,
                  type: 'error',
                });
                document.body.style.cursor = 'default';
              });
            } else {
              document.body.style.cursor = 'default';
            }
          });
        } finally {
          // console.log("我执行完了")
          // document.body.style.cursor="default";
        }
      }
    },
    // 修改弹窗
    editUserForm (row) {
      this.editFormVisible = true;
      this.editForm = util.deepCopy(row);
    },
    // 分配角色
    allot (row) {
      this.allotFormVisible = true;
      this.allotForm.USER_ID = util.deepCopy(row.ID);
      this.queryActorData();
    },
    // 分配项目点权限
    allotProject (row) {
      this.projectAuthorityFormVisible = true;
      this.projectAuthorityForm.USER_ID = util.deepCopy(row.ID);
      this.queryProjectData();
    },
    // 分配供应商权限
    allotSupplier (row) {
      this.supplierAuthorityFormVisible = true;
      this.supplierAuthorityForm.USER_ID = util.deepCopy(row.ID);
      this.querySupplierData();
    },
    // 修改用户信息
    submitEdit (formName) {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              const data = {
                TC_USER_ID: this.editForm.ID,
                NAME: this.editForm.NAME,
                CELLPHONE: this.editForm.CELLPHONE,
                DESCRIPTION: this.editForm.DESCRIPTION,
                TITLE: this.editForm.TITLE,
                DEPARTMENT_NAME: this.editForm.DEPARTMENT_NAME,
                WORK_POSITION: this.editForm.WORK_POSITION,
              };
              if (this.editForm.DEPARTMENT !== '') {
                data.DEPARTMENT_ID = this.editForm.DEPARTMENT_ID;
              }
              editUser(data).then((res) => {
                this.$message.show({
                  text: '修改企业人员信息成功',
                  type: 'success',
                });
                this.queryUserManageListData();
                this.editFormVisible = false;
                this.$refs[formName].resetFields();
                document.body.style.cursor = 'default';
              }).catch((error) => {
                this.$message.show({
                  text: error,
                  type: 'error',
                });
                document.body.style.cursor = 'default';
              });
            } else {
              document.body.style.cursor = 'default';
            }
          });
        } finally {
          // console.log("我执行完了")
          // document.body.style.cursor="default";
        }
      }
    },
    getDepartmentName (vId) {
      let obj = {};
      obj = this.departments.find((item) => /* 这里的userList就是上面遍历的数据源 */item.DEPARTMENT_ID === vId); // 筛选出匹配数据
      this.editForm.DEPARTMENT_NAME = obj.DEPARTMENT_NAME;
      this.editForm.DEPARTMENT_ID = vId;
    },
    // 重置密码
    changeUserPWD (row) {
      this.$confirm('您确定将该用户密码重置吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const data = { // http请求的参数
          TC_USER_ID: row.ID,
        };
        changeUserPWD(data).then((res) => {
          this.$message.show({
            text: '重置成功',
            type: 'success',
          });
          // this.queryUserManageListData();
        }).catch((error) => {
          this.$message.show({
            text: error,
            type: 'error',
          });
        });
      }).catch(() => {
        this.$message.show({
          type: 'info',
          text: '取消操作',
        });
      });
    },
    // 禁用用户
    stopUser (row) {
      this.$confirm('您确定将该用户禁用吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const data = { // http请求的参数
          TC_USER_ID: row.ID,
        };
        stopUser(data).then((res) => {
          this.$message.show({
            text: '禁用成功',
            type: 'success',
          });
          this.queryUserManageListData();
        }).catch((error) => {
          this.$message.show({
            text: error,
            type: 'error',
          });
        });
      }).catch(() => {
        this.$message.show({
          type: 'info',
          text: '取消操作',
        });
      });
    },
    // 启用用户
    startUser (row) {
      this.$confirm('您确定启用该用户吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const data = {
          TC_USER_ID: row.ID,
        };
        startUser(data).then((res) => {
          this.$message.show({
            text: '用户启用成功',
            type: 'success',
          });
          this.queryUserManageListData();
        }).catch((error) => {
          this.$message.show({
            text: error,
            type: 'error',
          });
        });
      }).catch(() => {
        this.$message.show({
          type: 'info',
          text: '取消操作',
        });
      });
    },
    // 关闭弹窗
    close (formName) {
      this.$refs[formName].resetFields();
      const modalName = `${formName}Visible`;
      this[`${modalName}`] = false;
    },
    handleCurrentChange () {
      this.queryUserManageListData();
    },
    handleSearch () {
      this.currentPage = 1;
      this.queryUserManageListData();
    },
    queryDepartment () {
      const params = {
        SERVICE_ID: '10012',
        OTYPE: 5,
        TC_ID: Number(sessionStorage.getItem('companyId')),
      };
      http.post(params).then((result) => {
        this.departments = result;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 匹配项目点
    configureProject (row) {
      this.$router.push({ path: `/configProjectDetail/${row.ID}/${row.NAME}`, params: { ID: row.ID, NAME: row.NAME } });
    },
    // 打开账号导出弹窗
    openExportDialog () {
      this.exportDialogVisible = true;
      this.queryAllActors();
    },
    // 获取全部角色（供复选框选择）
    queryAllActors () {
      getAllActor({ TC_ID: Number(sessionStorage.getItem('companyId')) }).then((res) => {
        // 根据后端实际返回结构调整，以下假设返回数组
        if (res && res.length > 0 && res[0].ACTOR_LIST) {
          this.actorOptions = res[0].ACTOR_LIST;
        } else if (Array.isArray(res)) {
          this.actorOptions = res;
        }
        // 初始化全选状态：如果已选中的数量等于总数量，则勾选全选
        if (this.actorOptions && this.actorOptions.length > 0) {
          this.checkAll = this.exportForm.actorIds.length === this.actorOptions.length;
        }
      }).catch((error) => {
        this.$message.show({
          text: error,
          type: 'error',
        });
      });
    },

    // 确认导出
    submitExport () {
      if (this.exportForm.actorIds.length === 0) {
        this.$message.show({
          text: '请至少选择一个角色',
          type: 'warning',
        });
        return;
      }
      const data = {
        ACTOR_IDS: this.exportForm.actorIds,
      };
      exportUserByActor(data).then((res) => {
        this.$message.show({
          text: '导出成功',
          type: 'success',
        });
        this.exportDialogVisible = false;
        this.resetExportForm();
        if (res && res.length > 0 && res[0].FILE_PATH) {
          window.open(res[0].FILE_PATH);
        }
      }).catch((error) => {
        this.$message.show({
          text: error,
          type: 'error',
        });
      });
    },
    // 关闭导出弹窗
    closeExportDialog () {
      this.exportDialogVisible = false;
      this.resetExportForm();
    },
    // 重置导出表单
    resetExportForm () {
      this.exportForm.actorIds = [];
      this.actorOptions = [];
      this.checkAll = false;
    },
    // 全选 / 取消全选
    handleCheckAllChange (val) {
      this.exportForm.actorIds = val
        ? this.actorOptions.map((item) => item.ACTOR_ID)
        : [];
    },
    // 手动勾选时同步全选状态
    handleCheckedActorsChange (value) {
      if (this.actorOptions && this.actorOptions.length > 0) {
        this.checkAll = value.length === this.actorOptions.length;
      } else {
        this.checkAll = false;
      }
    },

  },
  created () {
    if ('FORMAL_USER_MANAGE_SEARCH' in sessionStorage) {
      this.searchForm = JSON.parse(sessionStorage.getItem('FORMAL_USER_MANAGE_SEARCH'));
    }
    this.queryDepartment();
    this.queryUserManageListData();
  },

};
</script>
<style>
.look {
  margin-top: 33px !important;
}

.block {
  float: right;
}

/* 账号导出弹窗 - checkbox 竖排对齐 */
.export-actor-checkbox-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 300px;
  overflow-y: auto;
  padding-right: 8px;
}

.export-actor-checkbox-group .el-checkbox {
  margin-left: 0 !important;
}

/* 全选复选框底部留白，与列表区分 */
.export-check-all {
  margin-bottom: 8px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/formalUserManage.vue